const CONTENT_TRANSITION_DURATION_MS = 225;

// Since we need the content to be rendered before we can determine the vignette
// height we add a delay to the height transition in order to ensure proper
// heights have been set beforehand.
const CONTENT_RENDER_DELAY_MS = 30;
const contentTransitionCls = "_61ctos8vm";
const mobileContentTransitionCls = "_61m73mika";
const megaMenuCls = "_61m1d5g40k";
const wrapperCls = "_61w1lhgmyj";
const arrowCls = "_61a75xlft";
const contentCls = "_61c10rp22n";
const layerWrapperCls = "_61l1bw7bno";

/**
 * Layer around MegaMenu to allow for proper height-transition between two
 * MegaMenuLayers when filtering.
 */
const layerTransitionCls = "_61l17si1ym";
const headingCls = "_61h1xva828";
const goBackButtonCls = "_61gsfx4ba";
const closeButtonCls = "_61c14dgza1";
const backdropCls = "_61b13ukzk6";

export { CONTENT_RENDER_DELAY_MS, CONTENT_TRANSITION_DURATION_MS, arrowCls, backdropCls, closeButtonCls, contentCls, contentTransitionCls, goBackButtonCls, headingCls, layerTransitionCls, layerWrapperCls, megaMenuCls, mobileContentTransitionCls, wrapperCls };
import "./root.wrapper.style.linaria.module.css";
//# sourceMappingURL=root.wrapper.style.js.map
